import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ravelry': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M407.4 61.5c72.7 37.9 112 117.2 103.3 199.5-1.7 16.7-4.4 36.2-9.8 52.2-22.2 65.7-52.9 108.6-123.1 147.7-6.4 4.4-13.3 8.6-20.2 10.8-12.5 4.4-26.1 5.4-40.1 3.9-5.9 0.5-11.8 0.7-18 0.7-93.7 0-173-64-196.9-151.4-0.7 0-1.5-0.2-2.2-0.2-5.6 44.3 27.1 104.1 27.1 104.1s2 3 13.3 20.2c-62.8-33.2-64.5-131.2-64.5-131.2-15-5.6-67.2-23.4-76.3-37.9 0 0 40.9 22.4 76.2 27-0.2-0.3 0.5-7.9 0.5-7.9 2.2-30 12.5-53.4 23.1-71.4 6.9-33.8 22.1-64.3 43.3-89.9 3.7-15.3 9.6-33.5 19.9-52.7 4.4-8.4 8.6-13.8 19.9-19 74.9-35 148.7-43.9 224.5-4.5zM138.8 163.2c-7.6 11.3-13.7 23.6-18.9 36.4 8.1-8.6 14.8-14.2 18.2-16.7-0.5-7.4 0.7-19.7 0.7-19.7zM107.6 285.1c0.7 9.6 2 18.9 4.2 28.1l41.4 6.9c-14.1-42.1-15.8-90.1-15.8-90.1-16.5 16-25.4 37.9-29.8 55.1zM115.5 327.9c21.4 69.7 81 122.8 154.1 134.4-1-0.3-1.7-0.5-2.7-1 0 0-81-47.5-108.3-124.3-9.1-1.5-28.3-5.9-43.1-9.1zM386 444.1c63-32 106.6-98 106.8-174 0-107.4-86.6-194.5-193-194.5-49.3 0-94.1 18.7-128.3 49.5-5.2 10.1-8.6 22.9-11.1 39.4 52.5-44.6 146-33.5 146-33.5 23.4 1 20.6 21.7 20.4 28.1-85.2-7.2-127 17.2-168.4 52.4 0 0 8.1 78.8 26.8 110.8 107.8 4.9 189.8-53.7 189.8-53.7 10.3-7.4 19.4-8.1 21.4 4.7 1.5 10.4 2.2 24.4-9.6 29.8-36 16.8-75.6 27.3-115 33-25.6 3.7-39.8 4.6-78 3.9 36.4 84.7 127.5 107.8 127.5 107.8 28.5 4.7 50.2 1 64.7-3.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ravelry.js
// module id = 982
// module chunks = 0